import React from 'react';
// Styles
import { CardFilter as CardFilterStyle } from '../../../../pages/Filter/style';
import { TitleCard } from '../../../../pages/Filter/style';
import {
  CoverageContainer,
  CoverageTable,
  CoverageHeader,
  CoverageRow,
  CoverageCell,
  CoverageHeaderCell,
  CoverageLabel,
} from './style';

const PERFIS_COBERTURA = [7, 51, 86];
const TIPO_PESSOA_JURIDICA = 1;

/**
 * Componente de Tabela de Cobertura
 *
 * Exibe os percentuais de cobertura (30%, 50%, 75%, 100%)
 * com valores unitário e total para consulta do comercial.
 *
 *
 * @param {Object} props
 * @param {Object} props.data - Dados do produto retornados pela API filtrar (dataFilter)
 */
const BookCoverage = ({ data, title, order }) => {
  const isPerfilPermitido = React.useMemo(() => {
    try {
      const usuario = JSON.parse(localStorage.getItem('usuario'));

      if (!usuario) {
        return false;
      }

      const isPessoaJuridica = usuario.fk_tipo_usuario === TIPO_PESSOA_JURIDICA;
      const isPerfilValido = PERFIS_COBERTURA.includes(usuario.fk_perfil_usuario);

      return isPessoaJuridica || isPerfilValido;
    } catch {
      return false;
    }
  }, []);

  if (!isPerfilPermitido) {
    return null;
  }

  const { coberturas } = data || {};

  if (!coberturas || coberturas.length === 0) {
    return null;
  }

  const formatCurrency = (value) => {
    if (value == null || isNaN(value)) return 'R$ 0,00';
    return new Intl.NumberFormat('pt-BR', {
      style: 'currency',
      currency: 'BRL',
    }).format(value);
  };

  return (
    <CardFilterStyle>
      <TitleCard>
        <span>{order}</span>{title}
      </TitleCard>
      <CoverageContainer>
        <CoverageTable>
          <thead>
            <CoverageHeader>
              <CoverageHeaderCell>Cobertura</CoverageHeaderCell>
              <CoverageHeaderCell>Unitário</CoverageHeaderCell>
              <CoverageHeaderCell>Total</CoverageHeaderCell>
            </CoverageHeader>
          </thead>
          <tbody>
            {coberturas.map((item, index) => (
              <CoverageRow key={index}>
                <CoverageCell>
                  <CoverageLabel>{item.percentual}% de cobertura</CoverageLabel>
                </CoverageCell>
                <CoverageCell>{formatCurrency(item.valor_unitario)}</CoverageCell>
                <CoverageCell>{formatCurrency(item.valor_total)}</CoverageCell>
              </CoverageRow>
            ))}
          </tbody>
        </CoverageTable>
      </CoverageContainer>
    </CardFilterStyle>
  );
};

export default BookCoverage;